import { TextToVideo } from '@/features/ai-text-to-video-creator/components/TextToVideo';
import { ImagesModalSectionProps } from '@/features/media-modal/components/common/commonTypes';
import { BlockStack, Text } from '@shopify/polaris';

export const AiTextToVideoModalSection = ({ recommendation, product }: ImagesModalSectionProps) => {
  return (
    <BlockStack gap="400">
      <Text as="h2" variant="headingMd" fontWeight="bold">
        Text to Video
      </Text>
      <TextToVideo
        productId={product?.productId}
        productTitle={product?.title}
        initialPrompt={recommendation?.stockMediaQuery || ''}
        hideUseAction
      />
    </BlockStack>
  );
};
